export default function login() {
    
    var phpFile = "https://admin.crucearosie6.ro/php/login.php";

    return function(dispatch) {

        fetch(phpFile, {
            method: "GET",
            credentials: 'include'
        })
            .then(response => response.json())
            .then(data => {
                dispatch({
                    type: "LOGIN",
                    payload: data.status
                });
                dispatch({
                    type: "ROLES",
                    payload: data.roles
                });
                dispatch({
                    type: "USERID",
                    payload: data.id
                });
            })
    }
};


// WEBPACK FOOTER //
// ./src/actionCreators/login.js